export default __webpack_public_path__ + "static/media/track.660cb2d4.png";